import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import ChipInput from 'material-ui-chip-input';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Chip, Checkbox, FormControlLabel, TextField as MuiTextField } from '@material-ui/core';
import Modal from '../../../../components/Modal/Modal';
import TextField from '../../../../components/TextField/TextField';
import Button from '../../../../components/Button/Button';
import ProfileService from '../../../../services/ProfileService/ProfileService';
import SelectInput from '../../../../components/SelectInput/SelectInput';
import { CredentialPicker } from '../../../../components/FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import { alertState } from '../../../../recoil-store/recoil-state';
import { validateEmail } from '../../../../helpers/helper';
/**
 * @Description This function returns Save Alert dialog.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
const styles = {
    backgroundColor: '#fcfcfc',
    border: '1px solid #E6E6E6',
    minHeight: '25px !important',
    borderRadius: 5,
    paddingLeft: 5,
    paddingTop: 2,
    width: '90%'
};
const SendEmail = ({ state, handleChange, setState, t, action, getEditData }) => {
    const [testMail, setTestMail] = useState('');
    const [disableSendMail, setDisableSendMail] = useState(false);
    const setAlert = useSetRecoilState(alertState);
    const handleChangeMailInput = (event) => {
        setTestMail(event.target.value);
        if (validateEmail(event.target.value)) {
            setDisableSendMail(false);
        } else {
            setDisableSendMail(true);
        }
    };
    const handleAddChip = (chip, key) => {
        setState({
            ...state,
            [key]: [...state[key], chip],
        });
    };
    const handleDeleteChip = (chip, key) => {
        setState({
            ...state,
            [key]: state[key].filter(c => c !== chip),
        });
    };
    const onTestMail = async () => {
        if (!disableSendMail) {
            let data = getEditData(testMail, true);
            data.configurations.cc = [];
            const { status } = await ProfileService.testActioneerProfile(data);
            if (status) {
                setAlert(alert => ({ ...alert, show: true, message: t('CONTENT.ACTIONEER-PROFILE.SEND-TEST-MAIL-SUCCESS'), severity: 'success' }));
            } else {
                setAlert(alert => ({ ...alert, show: true, message: t('CONTENT.ACTIONEER-PROFILE.SEND-TEST-MAIL-ERROR'), severity: 'error' }))
            }
        }
    };
    return (
        <>
            <div className="form-element">
                <div>{t('CONTENT.ACTIONEER-PROFILE.HOST')}</div>
                <TextField name="host" value={state.host} onChange={handleChange} />
            </div>
            <div className="form-element">
                <div>{t('CONTENT.ACTIONEER-PROFILE.PORT')}</div>
                <TextField name="port" value={state.port} onChange={handleChange} />
            </div>
            <div className="form-element">
                <FormControlLabel
                    control={<Checkbox name="requires" color="primary" size="small" onChange={handleChange} checked={state.requires} />}
                    label={
                        <div style={{ fontSize: 13 }}>
                            {t('CONTENT.ACTIONEER-PROFILE.REQUIRES-AUTH')}
                        </div>
                    }
                />
            </div>
            {state.requires ? (
                <>
                    <div className="form-element">
                        <p>
                            {t('CONTENT.ACTIONEER-PROFILE.USERNAME')}
                        </p>
                        <div style={{ width: '100%' }} className="email-trigger-credentialpicker">
                            <CredentialPicker action={action} inputName="userName" isRequired={false} isVariableAdd={false} />
                        </div>
                        <p>
                            {t('CONTENT.ACTIONEER-PROFILE.PASSWORD')}
                        </p>
                        <div style={{ width: '100%' }} className="email-trigger-credentialpicker">
                            <CredentialPicker action={action} inputName="password" isRequired={false} isPassword={true} />
                        </div>
                    </div>
                </>
            ) : null}
            <div className="form-element">
                <div>{t('CONTENT.ACTIONEER-PROFILE.SENDER')}</div>
                <TextField name="sender" value={state.sender} onChange={handleChange} />
            </div>
            <div className="form-element">
                <div>{t('CONTENT.ACTIONEER-PROFILE.TO')}</div>
                <ChipInput
                    style={{
                        ...styles,
                    }}
                    fullWidth
                    newChipKeyCodes={[188]}
                    disableUnderline={true}
                    value={state.to}
                    onAdd={chip => handleAddChip(chip, 'to')}
                    onDelete={(chip, index) => handleDeleteChip(chip, 'to')}
                />
            </div>
            <div style={{ marginTop: -20 }}>
                <span className="dialog-text-small" style={{ fontSize: 9 }}>
                    {t('CONTENT.PUBLISH.AUTOM-TAG-DESC')}
                </span>
            </div>
            <div className="form-element">
                <div>{t('CONTENT.ACTIONEER-PROFILE.CC')}</div>
                <ChipInput
                    style={{
                        ...styles,
                    }}
                    fullWidth
                    newChipKeyCodes={[188]}
                    disableUnderline={true}
                    value={state.cc}
                    onAdd={(chip) => handleAddChip(chip, 'cc')}
                    onDelete={(chip, index) => handleDeleteChip(chip, 'cc')}
                />
            </div>
            <div style={{ marginTop: -20 }}>
                <span className="dialog-text-small" style={{ fontSize: 9 }}>
                    {t('CONTENT.PUBLISH.AUTOM-TAG-DESC')}
                </span>
            </div>
            <div className="form-element">
                <div>{t('CONTENT.ACTIONEER-PROFILE.SUBJECT')}</div>
                <TextField
                    name="subject"
                    value={state.subject}
                    onChange={handleChange}
                />
            </div>
            <div className="form-element">
                <div>{t('CONTENT.ACTIONEER-PROFILE.BODY')}</div>
                <TextField
                    name="body"
                    value={state.body}
                    onChange={handleChange}
                    multiline={true}
                />
            </div>
            <div className="form-element">
                <div style={{ width: '%90', borderTop: '1px solid #f8f8f8', marginTop: 10, marginBottom: 10 }} />
                <div className="mail-server-text">
                    {t('CONTENT.SETTINGS.MAIL-SERVER.TEST-MAIL')}*
                </div>
                <div
                    style={{ marginTop: 16, marginBottom: 11 }}
                    className="mail-server-input-text"
                >
                    <TextField value={testMail} name="testmail" onChange={handleChangeMailInput} />
                </div>
                <small onClick={onTestMail} style={{ pointerEvents: testMail.length <= 1 || disableSendMail ? 'none' : 'auto' }} className="mail-server-small-text-link">
                    {t('CONTENT.SETTINGS.MAIL-SERVER.SEND-TEST-MAIL')}
                </small>
            </div>
        </>
    );
};

const SaveAlert = ({ setOpen, onSave, open }) => {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const [action,] = useState({ fields: { userName: { value: '' }, password: { value: '' } } });
    const [state, setState] = useState({
        name: open.type === 'edit' ? open.item.name : '',
        rules: open.type === 'edit' ? open.item.rules : [],
        actioneerName: open.type === 'edit' ? open.item.actioneerName : '',
        type: open.type === 'edit' ? open.item.type : '',
        host: open.type === 'edit' ? open.item.host : '',
        port: open.type === 'edit' ? open.item.port : '',
        requires: open.type === 'edit' ? open.item.requires : false,
        sender: open.type === 'edit' ? open.item.sender : '',
        to: open.type === 'edit' ? open.item.to : [],
        cc: open.type === 'edit' ? open.item.cc : [],
        subject: open.type === 'edit' ? open.item.subject : '',
        body: open.type === 'edit' ? open.item.body : ''
    });
    const [alertRuleList, setAlertRuleList] = useState([]);

    useEffect(() => {
        fetchRules();
    }, []);

    const handleChange = (event) => {
        if (event.target.name === 'requires') {
            setState({ ...state, [event.target.name]: event.target.checked });
        } else {
            setState({ ...state, [event.target.name]: event.target.value });
        }
    };

    const getEditData = (testMail, isTest = false) => {
        const newData = {
            name: state.name,
            description: state.description,
            type: state.type,
            configurations: {
                sender: state.sender,
                to: isTest ? [testMail] : state.to,
                cc: state.cc,
                subject: state.subject,
                body: state.body
            },
            credentials: {
                host: state.host,
                port: state.port,
                require_authentication: state.requires,
                userName: action.fields.userName,
                password: action.fields.password
            }
        };
        if (!state.requires) {
            delete newData.credentials.userName;
            delete newData.credentials.password;
        }
        return newData;
    };

    const handleSave = (e) => {
        e.preventDefault();
        if (open.type === 'edit') {
            onSave(state, open.index);
        } else {
            onSave(state, -1);
        }
    };

    const fetchRules = async () => {
        const response = await ProfileService.getAllAlertRules();
        if (response) {
            if (response?.status) {
                setAlertRuleList(response.data);
            }
        }
    };

    const handleRulesChange = (e, newValue) => {
        setState({ ...state, rules: newValue });
    };

    return (
        <Modal title={t(label + 'ADD-ALERT')} setOpen={setOpen}>
            <div style={{ marginLeft: 15 }}>
                <div className="form-element">
                    <div>{t(label + 'ALERT-NAME')}</div>
                    <TextField name="name" value={state.name} onChange={handleChange} />
                </div>
                <div className="form-element">
                    <div>{t('CONTENT.ALERT.RULES')}</div>
                    <Autocomplete multiple freeSolo size="small" value={state.rules}
                        onChange={handleRulesChange} style={{ width: '90%' }}
                        options={alertRuleList}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip variant="outlined" label={option.message} {...getTagProps({ index })} key={index} />
                            ))
                        }
                        getOptionLabel={option => option.message}
                        renderInput={params => <MuiTextField {...params} variant="outlined" />}
                    />
                </div>
                <div className="form-element">
                    <div>{t(label + 'ACTIONEER-NAME')}</div>
                    <TextField name="actioneerName" value={state.actioneerName} onChange={handleChange} />
                </div>
                <div className="form-element">
                    <div>{t('CONTENT.ACTIONEER-PROFILE.TYPE')}</div>
                    <SelectInput
                        value={state.type}
                        name="type"
                        param="type"
                        data={[{ type: 'SEND-MAIL' }]}
                        valueKey="type"
                        onChange={handleChange}
                    />
                </div>
                {state.type === 'SEND-MAIL' ? (
                    <SendEmail
                        handleChange={handleChange}
                        state={state}
                        setState={setState}
                        action={action}
                        getEditData={getEditData}
                        t={t}
                    />
                ) : null}
            </div>
            <div
                className="form-element"
                style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                }}
            >
                <Button
                    value={t('PARAMS-MODAL.CANCEL')}
                    color="#031226"
                    bgColor="#fff"
                    border="1px solid #031226"
                    onClick={() => setOpen(false)}
                />
                {open?.type === 'edit' ? (
                    <Button
                        value={t('PARAMS-MODAL.EDIT')}
                        onClick={handleSave}
                    />
                ) : (
                    <Button
                        value={t('PARAMS-MODAL.ADD')}
                        onClick={handleSave}
                    />
                )}
            </div>
        </Modal>
    );
};
export default SaveAlert;